import { Component } from '@angular/core';

@Component({
  selector: 'pt-sign-layout',
  template: `
    <div class="w-100 h-100 auth-layout">
      <div class="image-content">
        <ng-content select="[carousel]"></ng-content>
        <ng-content select="[staticImage]"></ng-content>
      </div>
      <div class="form-content">
        <ng-content select="[sign]"></ng-content>
      </div>
    </div>
  `,
  styles: [`
    .auth-layout {
      display: grid;
      grid-template-columns: 1fr 414px;
      grid-template-rows: 1fr;
      gap: 0 0;
      grid-template-areas: "image-content form-content";
    }
    .form-content { grid-area: form-content;       overflow: hidden;}
    .image-content { grid-area: image-content;       overflow: hidden;}
  `]
})
export class SignLayoutComponent {
}
